import { createContext } from "react";
import type { OnlinePaymentsConfigContextType } from "./types";

export const OnlinePaymentsConfigContext = createContext<
  OnlinePaymentsConfigContextType | undefined
>(undefined);
